export default {
  admin: 'Admin',
  password: {
    enterNewPassword: 'Masukkan kata sandi baru',
    reenterNewPassword: 'Masukkan kembali kata sandi baru',
    updatePassword: 'Perbarui Kata Sandi',
    setPassword: 'Atur Kata Sandi',
    min8CharacterMessage: 'Kata sandi harus terdiri dari minimal 8 karakter',
    passwordSentMessage: 'Kata sandi telah dikirim ke {userName} melalui email.',
    generateNewPassword: 'Buat Kata Sandi Baru',
    assignPasswordMessage:
      'Tetapkan kata sandi untuk pengguna. Pengguna akan diminta untuk mengubah kata sandi ini pada saat login berikutnya.',
    generateSecurePassword: 'Buat kata sandi yang aman',
    newPassword: 'Kata Sandi Baru',
    confirmNewPassword: 'Konfirmasi Kata Sandi Baru',
    passwordHistory: 'Riwayat Kata Sandi',
    passwordUpdatedLog: 'Kata sandi diperbarui oleh {userName} pada {date}.',
    forgotPasswordLog: 'Permintaan lupa kata sandi dikirim oleh {userName} pada {date}.',
  },
};
